import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      position: 'absolute',
      width: 'calc(100% - 80px)',
      height: '1px',
      left: 0,
      margin: '0 40px',
      background: palette.background.dark
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
